import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { collection, query, where, getDocs, orderBy } from "firebase/firestore";
import OptimizedImage from "./ΟptimizedImage";
// ΔΙΟΡΘΩΣΗ: Πρέπει να γίνει import το 'db' και όχι το 'Db' για να δουλέψει με το Firestore.
// Υποθέτουμε ότι το αρχείο firebase εξάγει το instance του Firestore ως 'db'.
import { Db} from "./../firebase"; 

// Remove HTML tags
const stripHtml = (html) => {
  if (!html) return "";
  try {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  } catch (error) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  }
};

// 🛑 ΑΦΑΙΡΕΘΗΚΕ: Αυτή η συνάρτηση δεν είναι πλέον αξιόπιστη
// const isGreek = (text) => /[α-ωΑ-Ω]/.test(text);

// Helper function to format the date securely
const formatDate = (timestamp) => {
  if (timestamp && typeof timestamp.toDate === 'function') {
    try {
      return timestamp.toDate().toLocaleDateString("el-GR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    } catch (e) {
      console.error("⚠️ Date formatting error:", e);
      return "Unknown Date";
    }
  }
  return "Unknown Date";
};


const TopNewsSection = () => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const fetchTopNews = async () => {
      try {
        // ΔΙΟΡΘΩΣΗ: Χρησιμοποιούμε 'db'
        const q = query(
          collection(Db, "posts"),
          where("category", "==", "topnews"), // ⚠️ ΠΡΟΣΟΧΗ: Αυτό ψάχνει για "topnews", όχι "reviews"
          where("status", "==", "published"),
          orderBy("createdAt", "desc")
        );
        const snapshot = await getDocs(q);
        const fetched = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setArticles(fetched);
      } catch (err) {
        console.error("⚠️ Error loading Top News:", err);
      }
    };

    fetchTopNews();

  }, []);

  if (!articles || articles.length === 0) return null;

  // ✅ ΔΙΟΡΘΩΣΗ: Διαχωρισμός βάσει του πεδίου 'language' από τη Firestore
  const greekArticles = articles.filter(
    (a) => a.language === 'el'
  );
  const englishArticles = articles.filter(
    (a) => a.language !== 'el' // Οτιδήποτε δεν είναι 'el' (π.χ. 'en' ή κενό)
  );

  /**
   * Reusable layout renderer:
   * Adopts the Light Bootstrap Grid layout (8/12 - 4/12) matching the ReviewSection/latest image.
   */
  const renderArticles = (list, sectionTitle) => {
    // Get the featured article (most recent) and the next 4 (others)
    const featured = list[0];
    const others = list.slice(1, 5);

    if (!featured) return null;
    
    // Placeholder Image URL
    const placeholderUrl = "https://placehold.co/1200x600/343a40/f8f9fa?text=TOP+NEWS";

    return (
      // Κάθε κλήση αυτής της συνάρτησης επιστρέφει ένα ξεχωριστό <section>
      <section className="reviews-section py-5">
        <div className="container">
          {/* Section Title - Dark text, dark border (as seen in the image) */}
          <h2 className="text-dark fw-bold border-bottom border-2 border-dark d-inline-block mb-4 px-2">
            {sectionTitle}
          </h2>

          <div className="row">
            {/* Featured Article (8/12) */}
            <div className="col-md-8 mb-4 mb-md-0 position-relative">
              <div className="position-relative">
                <Link to={`/articles/${featured.id}`}>
                    <OptimizedImage
                        src={featured.mainImageUrl || placeholderUrl}
                        alt={featured.title}
                        className="img-fluid w-100 rounded"
                        style={{ height: "420px", objectFit: "cover" }}
                    />
                </Link>
                {/* Tag - Dark background, White text (as seen in the image) */}
                <span
                  className="position-absolute top-0 start-0 bg-dark text-white px-2 py-1 small"
                  style={{ borderBottomRightRadius: "4px" }}
                >
                  Top News
                </span>
              </div>

              {/* Text Content - Dark text */}
              <div className="mt-3 text-dark">
                <Link
                  to={`/articles/${featured.id}`}
                  className="text-decoration-none"
                >
                  {/* Title - Dark text, hover with accent color (yellow/warning) */}
                  <h3 className="fw-bold text-dark hover-text-warning">
                    {featured.title}
                  </h3>
                </Link>
                <p className="text-muted small mb-2">
                  {formatDate(featured.createdAt)}
                </p>
                {/* Summary - Gray/Secondary color */}
                <p className="text-secondary" style={{ maxWidth: "95%" }}>
                  {stripHtml(featured.content)?.slice(0, 220)}...
                </p>
                
                {/* Author Info */}
                <p className="text-muted small">
                  Από: <span className="fw-semibold">{featured.author || "Συντακτική Ομάδα"}</span>
                </p>

                {/* Comment Counter (Black Box, White Text) */}
                <div
                  className="position-absolute bottom-0 end-0 bg-dark text-white px-2 py-1 d-flex align-items-center rounded-start"
                  style={{ fontSize: "0.85rem" }}
                >
                  <i className="bi bi-eye me-1"></i> 0
                </div>
              </div>

              {/* Pagination/Controls (buttons) - Yellow/Warning Outline */}
              <div className="mt-4">
                <button className="btn btn-outline-warning btn-sm me-2">
                  <i className="bi bi-arrow-left"></i>
                </button>
                <button className="btn btn-outline-warning btn-sm">
                  <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>

            {/* Side Articles (4/12) */}
            <div className="col-md-4">
              {others.map((article) => (
                <div
                  key={article.id}
                  className="d-flex align-items-center mb-3 border-bottom border-secondary pb-2"
                >
                  <Link to={`/articles/${article.id}`}>
                    <img
                      src={article.mainImageUrl || placeholderUrl}
                      alt={article.title}
                      className="img-fluid me-3 rounded"
                      style={{
                        width: "100px",
                        height: "70px",
                        objectFit: "cover",
                      }}
                    />
                  </Link>
                  <div>
                    <Link
                      to={`/articles/${article.id}`}
                      className="text-dark text-decoration-none"
                    >
                      {/* Title - Dark text, hover with accent color */}
                      <h6 className="fw-semibold mb-1 hover-text-warning">
                        {article.title}
                      </h6>
                    </Link>
                    <p className="text-muted small mb-0">
                      {formatDate(article.createdAt)}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  };

  return (
    <>
      {/* Κάθε section καλείται ξεχωριστά, δημιουργώντας δύο διαφορετικά grids */}
      {greekArticles.length > 0 && renderArticles(greekArticles, "TOP NEWS (GR)")}
      {englishArticles.length > 0 && renderArticles(englishArticles, "TOP NEWS (EN)")}
    </>
  );
};

export default TopNewsSection;
